// `space-home`가 owner를 Space 컬럼에서 정규화할 때는 Node 카드가 알지 못하는
// 생애 상태를 꾸며내지 않으므로 `state`를 보내지 않는다. 부재는 active로 읽고,
// Gateway가 실제 멤버십 행으로 보낸 비활성 상태만 후보에서 제외한다.
export function isEligibleTaskRecipient(member) {
  return (member.state ?? 'active') === 'active' && ['owner', 'member', 'steward'].includes(member.role);
}

// `task-context-pack.participants` 는 Space 멤버십이 아니라 Task의 참여 계약이다.
// 질문·넘김 후보는 이 목록에서만 고른다. `removedAt`이 null이고 owner/participant인
// 사람만 아직 Task의 판단에 참여할 수 있다.
export function isActiveTaskParticipant(participant) {
  return participant.removedAt === null && ['owner', 'participant'].includes(participant.role);
}
